{
  "name": "afterpic",
  "version": "1.9.0",
  "scripts": {
    "ng": "ng",
    "start": "bun scripts/serve-dev.ts",
    "start:staging": "bun scripts/serve-staging.ts",
    "start:admin": "bun scripts/serve-admin.ts",
    "cert:generate": "bun run scripts/generate-cert.js",
    "start:external": "bun ng serve --host 0.0.0.0 --port 4300 --ssl",
    "start:admin:prod": "bun ng serve afterpic-admin --port 4301 --configuration production",
    "prebuild": "bun run i18n",
    "build": "ng build",
    "build:admin": "ng build afterpic-admin --configuration production",
    "build:prod": "bun scripts/build-prod.ts",
    "build:mobile": "ng build --configuration mobile",
    "watch": "ng build --watch --configuration development",
    "test:admin": "ng test afterpic-admin --watch=false --browsers=ChromeHeadless",
    "test:watch": "ng test --watch",
    "test:coverage": "ng test --code-coverage",
    "serve:prod": "bun dist/afterpic/server/server.mjs",
    "assets:convert:webp": "bun scripts/convert-styles-to-webp.ts",
    "assets:convert-all:webp": "bun scripts/convert-assets-to-webp.ts",
    "assets:generate-scenes": "bun scripts/generate-scene-images.ts",
    "assets:generate-scenes:skip-existing": "bun scripts/generate-scene-images.ts --skip-existing",
    "assets:generate-scenes:test": "bun scripts/generate-scene-images.ts --test",
    "assets:generate-product-styles": "bun scripts/generate-product-styles.ts",
    "assets:generate-product-styles:skip-existing": "bun scripts/generate-product-styles.ts --skip-existing",
    "assets:generate-product-styles:test": "bun scripts/generate-product-styles.ts --test",
    "assets:rename-scenes": "bun scripts/rename-scene-files.ts",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:mock-ai": "bun run scripts/test-mock-ai.js",
    "test:mock-quick": "bun run scripts/test-mock-ai.js --quick",
    "test:mock-themes": "bun run scripts/test-mock-ai.js --theme landscape && bun run scripts/test-mock-ai.js --theme portrait && node scripts/test-mock-ai.js --theme abstract",
    "test:backend": "bun test ./backend/src/**/*.spec.ts",
    "test:backend:file": "bun test",
    "test": "bun test --coverage",
    "clean-tests": "bun run scripts/clean-tests.js",
    "i18n": "bun scripts/generate-i18n-types.ts",
    "validate:i18n": "bun scripts/validate-translations.ts src/assets/i18n",
    "validate:styles": "bun scripts/validate-styles.ts src/assets/i18n backend",
    "validate:styles:comprehensive": "bun scripts/validate-styles-comprehensive.ts",
    "translate:styles": "bun scripts/auto-translate-styles.ts",
    "translate:styles:auto": "bun scripts/auto-translate-styles.ts --auto-accept --validate-first",
    "translate:styles:es": "bun scripts/auto-translate-styles.ts --languages es --auto-accept",
    "translate:styles:pt-br": "bun scripts/auto-translate-styles.ts --languages pt-BR --auto-accept",
    "pm2:start": "pm2 start ecosystem.config.cjs --env production",
    "pm2:stop": "pm2 stop afterpic-frontend",
    "pm2:restart": "pm2 restart afterpic-frontend",
    "pm2:logs": "pm2 logs afterpic-frontend",
    "pm2:status": "pm2 status"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/aria": "^21.0.5",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/platform-browser": "^21.0.6",
    "@angular/platform-server": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@angular/service-worker": "^21.0.6",
    "@angular/ssr": "^21.0.4",
    "@capacitor/android": "^8.0.0",
    "@capacitor/angular": "2.0.3",
    "@capacitor/core": "^8.0.0",
    "@capgo/capacitor-social-login": "^8.2.9",
    "@fastify/compress": "^8.3.1",
    "@fastify/helmet": "^13.0.2",
    "@fastify/static": "^9.0.0",
    "@fortawesome/angular-fontawesome": "4.0.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.1.0",
    "@fortawesome/pro-light-svg-icons": "^7.1.0",
    "@fortawesome/pro-regular-svg-icons": "^7.1.0",
    "@fortawesome/pro-solid-svg-icons": "^7.1.0",
    "@simplewebauthn/browser": "^13.2.2",
    "@stripe/stripe-js": "^8.6.0",
    "@types/three": "^0.182.0",
    "comfyui-node": "1.8.1",
    "echarts": "^6.0.0",
    "fastify": "^5.6.2",
    "fuse.js": "^7.1.0",
    "gsap": "^3.14.2",
    "idb": "^8.0.3",
    "konva": "^10.0.12",
    "ng2-konva": "^11.0.0",
    "rxjs": "~7.8.2",
    "three": "^0.182.0",
    "tslib": "^2.8.1",
    "zod": "^4.3.4"
  },
  "devDependencies": {
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.6",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@capacitor/cli": "^8.0.0",
    "@tailwindcss/postcss": "^4.1.18",
    "@types/bun": "1.3.5",
    "@types/cors": "^2.8.19",
    "@types/jasmine": "~5.1.13",
    "@types/node": "^25.0.3",
    "baseline-browser-mapping": "^2.9.11",
    "jasmine-core": "~5.13.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.6",
    "sharp": "0.34.5",
    "tailwindcss": "^4.1.18",
    "typescript": "~5.9.3",
    "vitest": "^4.0.16"
  },
  "trustedDependencies": [
    "@parcel/watcher",
    "@tailwindcss/oxide",
    "esbuild",
    "lmdb",
    "msgpackr-extract",
    "sharp"
  ]
}